<template>
	<div class="data-type">
		<ul>
			<li v-for="(item, i) in typeData" :key="i" :class="{'active':item.type === curType}" @click="selectData(item)">
				{{item.name}}
				<!-- <template v-if="item.code === 'more'">
					<span class="i-more180">▲</span>
					<dl class="type-more">
						<dd v-for="(child,x) in item.child" :key="x" @click.stop="selectDataChild(i,child)">{{child.name}}</dd>
					</dl>
				</template> -->
			</li>
		</ul>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
	name: 'TypeSelect',
	data() {
		return {

		}
	},
	computed: {
		...mapState('siteStas', ['typeData', 'curType'])
	},
	methods: {
		...mapMutations('siteStas', ['setCurType']),
		selectData(curType) {
			if(curType.code === 'more') return
			this.typeData.forEach(item => {
				item.act = false
			})
			// this.typeData[2].name = '其它'

			curType.act = true
			this.setCurType(curType.type)
		},
		selectDataChild(index,curType) {
			this.typeData[index].name = curType.name
			this.typeData[index].type = curType.code
			this.typeData.forEach(item => {
				item.act = false
			})
			this.typeData[index].act = true
			this.setCurType(curType.code)
		}
	}
}
</script>

<style lang="scss" scoped>
    .data-type {
        height: 27px; //width: 212px;
        line-height: 20px;
        text-align: center;
        ul {
            margin: 0;
            padding: 0;
			font-size: 12px;
			display: flex;
            li {
				width: 16.6%;
                position: relative;
                height: 30px;
                cursor: pointer;
                line-height: 30px;
                border: solid 1px #ececec;

                &:last-of-type {
                    border-radius: 2px 0 0 2px;
                }
                &:last-of-type {
                    border-radius: 0 2px 2px 0;
                }
                &.active {
                    background-color: $colorA;
                    border: 1px solid $colorA;
                    color: #ffffff;
                    .btn {
                        background-color: $colorA;
                    }
                }
            }
        }
        .btn-group .btn {
            height: 21px;
            line-height: 12px;
            background-color: white;
            box-shadow: none;
            color: #515567;
            position: relative;
        }
        .btn-group .btn:hover {
            border: inherit;
            background: inherit;
            color: #f08300;
        }
    }
    .i-more180{
        display: inline-block;transform:rotate(180deg);vertical-align: middle;
    }
</style>
